import React, { Dispatch, ReactNode, useCallback, useState } from "react";
import AdminSidebar from "../admin/AdminSidebar";
import { AdminFooter } from "../admin/AdminFooterLayout";
import { Toaster } from "../ui/sonner";
import { AdminView } from "@/App";
import { AdminHeader } from "../admin/AdminHeader";
import UserManagement from "../UserManagement";
import BachelorDegreeManagement from "../BachelorDegreeManagement"
import MasterDegreeManagement from "../MasterDegreeManagement"
import LanguageCertificateManagement from "../LanguageCertificateManagement"
import AwardManagement from "../AwardManagement"
import ScholarshipManagement from "../ScholarshipManagement"
import ScholarshipTitleManagement from "../ScholarshipTitleManagement"
import AdminDashboardOverview from "../admin/AdminDashboardOverview";
import { useAuthStore } from "@/lib/stores/auth";

export default function AdminPage({ logout }: { logout: () => void }) {
	const { isAuthenticated } = useAuthStore();
	const [currentView, onViewChange] = useState<AdminView>("dashboard");


	if (isAuthenticated === false) {
		return <div className="flex items-center justify-center h-screen">
			<p className="text-lg">Bạn chưa đăng nhập hoặc phiên đăng nhập đã hết hạn. Vui lòng đăng nhập để tiếp tục.</p>
		</div>
	}

	const renderView = useCallback((viewName: AdminView) => {
		switch (viewName) {
			case "users":
				return <UserManagement />;
			case "bachelor-degrees":
				return <BachelorDegreeManagement />;
			case "master-degrees":
				return <MasterDegreeManagement />;
			case "language-certificates":
				return <LanguageCertificateManagement />;
			case "awards":
				return <AwardManagement />;
			case "scholarship":
				return <ScholarshipManagement />;
			case "scholarship-title":
				return <ScholarshipTitleManagement />;
			default:
				return <AdminDashboardOverview />;
		}
	}, [])

	return (
		<div className='h-screen w-screen bg-background flex'>
			<AdminSidebar currentView={currentView} onViewChange={onViewChange} />

			<div className='flex-grow flex flex-col'>
				<AdminHeader logout={logout} />
				<main className='p-6 h-0 flex-grow overflow-y-scroll'>{renderView(currentView)}</main>
				<AdminFooter />
			</div>

			<Toaster expand={true} />
		</div>
	);
}
